<template>
  <b-dropdown dropdown text="My profile" variant="link">
    <b-dropdown-item to="/profile">My data</b-dropdown-item>
    <b-dropdown-item to="/subscription">My subscription</b-dropdown-item>
    <b-dropdown-item @click="onLogout">Logout</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  methods: {
    async onLogout () {
      await this.$store.dispatch('auth/logout')
      window.$chatwoot.reset()
      this.$bvToast.toast('Logout!', {
        title: 'Success',
        variant: 'success',
        solid: true
      })
      this.$router.push({ name: 'login' })
    }
  }
}
</script>
